module.exports = __webpack_public_path__ + "img/face-flip-card-back.b0f029e3.png";